define('drops/modalAction/ModalActionMpa',[
    'jquery',
    'lq'
], function ($, lq) {
    'use strict';

    var dimensionsUpdateIntervalInMilliseconds = 300;

    var ModalActionMpa = function (modalAction) {
        this.modalAction = modalAction;

        this.onMessageReceived = this.receivedMessage.bind(this);
        this.sizeUpdateIntervaldId = null;
    };

    ModalActionMpa.prototype.setUp = function () {
        this.$iframe = $('<iframe />')
            .attr('scrolling', this.modalAction.data.scrolling)
            .css({
                width: '100%',
                height: '100%',
                border: 0,
                display: 'none',
                allowtransparency: true
            })
            .appendTo(this.modalAction.$element);
        window.addEventListener('message', this.onMessageReceived, false);
    };

    ModalActionMpa.prototype.show = function () {
        this.$iframe
            .attr('src', this.getIframeUrl())
            .css('display', 'inherit');
        
        if (!this.sizeUpdateIntervaldId && this.modalAction.$element.css('position') === 'relative') {
            var self = this;
            this.$iframe.on('load', function () {
                if (self.sizeUpdateIntervaldId) return;

                self.sizeUpdateIntervaldId = setInterval(function () {
                    if (!self.$iframe[0].contentWindow) return;

                    var nestedLicquidContainer = $(self.$iframe[0].contentWindow.document.body).find('.licquid-action-wrapper');
                    if (nestedLicquidContainer.length === 0) return;

                    nestedLicquidContainer.css('overflow', 'hidden');

                    self.$iframe.width(nestedLicquidContainer[0].scrollWidth);
                    self.modalAction.$element.width(nestedLicquidContainer[0].scrollWidth);

                    self.$iframe.height(nestedLicquidContainer[0].scrollHeight);
                    self.modalAction.$element.height(nestedLicquidContainer[0].scrollHeight);

                }, dimensionsUpdateIntervalInMilliseconds);
            });
        }
    };

    ModalActionMpa.prototype.hide = function () {
        if (!this.$iframe) return;

        if (this.sizeUpdateIntervaldId) {
            clearInterval(this.sizeUpdateIntervaldId);
            this.sizeUpdateIntervaldId = null;
        }

        this.$iframe
            .attr('src', '')
            .css('display', 'none');
    };
    
    ModalActionMpa.prototype.getIframeUrl = function () {
        var actionId = this.modalAction.getActionId()

        if (!actionId) return '';

        var targetUrl = lq.getTenantUrl('LicquidAction/Get/' + actionId);

        var params = {};

        var globals = this.modalAction.piping.parameters.globals.getAll();
        if (_.keys(globals).length > 0)
            params.globals = JSON.stringify(globals);

        var explicitlyMappedParams = this.modalAction.getParametersForIframe();
        if (_.keys(explicitlyMappedParams).length > 0)
            params.parameters = JSON.stringify(explicitlyMappedParams);
        
        return this.modalAction.piping.url.prepare(targetUrl, params);
    };
    
    ModalActionMpa.prototype.receivedMessage = function (message) {
        var eventObj = this.getEventFromMessage(message);
        if (!eventObj) return;

        if (eventObj.eventName === 'EmbeddedActionLoaded' && this.modalAction.data.useSelectedActionSize) {
            this.modalAction.setElementSizeBasedOnAnchoring(this.modalAction.data, eventObj);
        } else {
            // staying backwards compatible with existing custom code
            var args = eventObj.args ? eventObj.args[0] : null;
            this.modalAction.triggerEvent(this.modalAction.data.id + '.' + eventObj.eventName, args);
        }
    };

    ModalActionMpa.prototype.getEventFromMessage = function(e) {
        if (e.source !== this.$iframe.get(0).contentWindow)
            return undefined;

        try {
            var eventObj = JSON.parse(e.data);
            return eventObj;
        } catch (err) {
            //could not parse, ignore it
        }

        return undefined;
    }

    ModalActionMpa.prototype.triggerEventForChild = function (eventObj) {
        var targetOrigin = this.modalAction.rootDrop.data.embeddable
            ? '*'
            : window.location.protocol + '//' + window.location.host;
        this.$iframe.get(0).contentWindow.postMessage(JSON.stringify(eventObj), targetOrigin);
    };

    ModalActionMpa.prototype.onError = $.noop;

    ModalActionMpa.prototype.dispose = function() {
        window.removeEventListener('message', this.onMessageReceived);
    };

    return ModalActionMpa;
});

